// Centralized map + editing-tool colors. Mapbox paint properties and canvas
// drawing need raw hex values, so these live here rather than as CSS tokens.
// "covered" is the brand green; it stays a touch brighter than the deep forest
// UI accent so completed streets read clearly against the muted map.
export const MAP_COLORS = {
  // Street network
  street: "#82a0a0", // uncovered streets
  covered: "#3f9d63", // streets you've run (brand green)
  stravaRun: "#FC4C02", // raw Strava run tracks (official Strava orange)

  // Route planning
  routeStart: "#10b981",
  waypoint: "#f97316",
  routeLine: "#f97316",
  pointStroke: "#ffffff",

  // Suggested routes (uncovered-street coverage suggestions)
  suggestedRoute: "#7c5cbf", // muted violet, distinct from the orange route line
  suggestedStart: "#2c5e42", // brand forest green (matches the UI primary accent)
  suggestedEnd: "#b45309", // muted amber, distinct from the forest start pin
  routeArrow: "#f97316", // matches the orange route line
  routeAnimation: "#c2410c", // deeper orange for the reveal trail + dot

  // Completion brush (mark streets done)
  brush: "#3b82f6",
  brushPreview: "#fbbf24",
  brushActive: "#f59e0b",

  // Incomplete brush (erase coverage)
  erase: "#ef4444",
  erasePreview: "#fca5a5",

  // Delete tool
  delete: "#FF4444",
} as const;
